import { SPACING } from '@alto/design-library-tokens';
// @owners { team: patient-health }
import { ActionSheetContext, ActionSheetV2, Body, Button, LgPadding, XsSpacing } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React, { useContext } from 'react';
import FamilyImage from '~shared/assets/images/add_family_member.png';
import { ASSISTANT_MESSAGE_SUBJECTS } from '~shared/features/alto-assistant/constants';

export const AddFamilyMemberActionSheet = () => {
  const { navigate } = useNavigation();
  const { closeActionSheet } = useContext(ActionSheetContext);

  const handleSendMessagePress = () => {
    closeActionSheet();
    navigate('RouteAssistantMessage', {
      messagePrompt: 'Please include full name and date of birth for each family member.',
      subject: ASSISTANT_MESSAGE_SUBJECTS.ADD_FAMILY_MEMBER,
      origin: 'add_family_member_action_sheet',
      category: 'account.add_family_member',
      isEditableSubject: false,
      message:
        'Hi, I would like to add a family member to my account. Please see below for their information:\n\nFull name:\nDate of birth:\nRelationship to me:\n\nThank you!',
    });
  };

  return (
    <ActionSheetV2
      title="Add a family member"
      illustrationSrc={FamilyImage}
      buttons={[
        <Button
          key="add-family-member-via-message"
          label="Send a message"
          onPress={handleSendMessagePress}
        />,
        <Button
          key="add-family-member-got-it"
          label="Got it"
          onPress={closeActionSheet}
          type="tertiary"
        />,
      ]}
      analyticsName="add family member"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>
          Manage your family’s prescriptions, all in one place! You can schedule deliveries, order refills, and update
          insurance on their behalf.
        </Body>
        <XsSpacing />
        <Body>
          To add a family member to your account, please send us a message that includes their full name, date of birth,
          and your relationship to that person. Please note that any family member 18 years or older will need to
          provide oral or written authorization before we can add them to your account.
        </Body>
      </LgPadding>
    </ActionSheetV2>
  );
};
